import { Box } from "@mui/material";
import { styled } from "@mui/material/styles";
import TableCell, { tableCellClasses } from "@mui/material/TableCell";

export const StyledCenterAlignedTableCell = styled(TableCell)(({ theme }) => ({
  [`&.${tableCellClasses.head}`]: {
    backgroundColor: "#62626E",
    color: theme.palette.common.white,
    textAlign: "center",
    fontWeight: "bold",
  },
  "&.text-wrapper": {
    maxWidth: "150px",
    // overflowWrap: "anywhere"
  },
  "&.wrapLargeText": {
    overflowWrap: "anywhere",
  },
  [`&.${tableCellClasses.body}`]: {
    fontSize: 14,
    textAlign: "center",
  },
}));

export const StyledTableCell = styled(TableCell)(({ theme }) => ({
  [`&.${tableCellClasses.head}`]: {
    backgroundColor: "#62626E",
    color: theme.palette.common.white,
    textAlign: "center",
    fontWeight: "bold",
  },
  "&.text-wrapper": {
    maxWidth: "150px",
    // overflowWrap: "anywhere"
  },
  "&.wrapLargeText": {
    overflowWrap: "anywhere",
  },
  [`&.${tableCellClasses.body}`]: {
    fontSize: 14,
    textAlign: "left",
  },
}));

export const LeftStyledTableCell = styled(TableCell)(({ theme }) => ({
  [`&.${tableCellClasses.head}`]: {
    backgroundColor: "#62626E",
    color: theme.palette.common.white,
    textAlign: "left",
    fontWeight: "bold",
  },
  "&.text-wrapper": {
    maxWidth: "150px",
    // overflowWrap: "anywhere"
  },
  "&.text-wrapper-store_list": {
    maxWidth: "200px",
    // overflowWrap: "anywhere"
  },
  "&.wrapLargeText": {
    overflowWrap: "anywhere",
  },
  [`&.${tableCellClasses.body}`]: {
    fontSize: 14,
    textAlign: "left",
  },
}));

export const ExtraPaddingLeftStyledCell = styled(TableCell)(({ theme }) => ({
  [`&.${tableCellClasses.head}`]: {
    backgroundColor: "#62626E",
    color: theme.palette.common.white,
    textAlign: "left",
    fontWeight: "bold",
    paddingLeft: "40px",
  },
  "&.text-wrapper": {
    maxWidth: "150px",
    // overflowWrap: "anywhere"
  },
  "&.wrapLargeText": {
    overflowWrap: "anywhere",
  },
  [`&.${tableCellClasses.body}`]: {
    fontSize: 14,
    textAlign: "left",
    paddingLeft: "40px",
  },
}));

export const SmallWidthStyledTableCell = styled(TableCell)(({ theme }) => ({
  [`&.${tableCellClasses.head}`]: {
    backgroundColor: "#62626E",
    color: theme.palette.common.white,
    textAlign: "left",
    fontWeight: "bold",
  },
  "&.text-wrapper": {
    width: "65px",
    // overflowWrap: "anywhere"
  },
  "&.wrapLargeText": {
    overflowWrap: "anywhere",
  },
  [`&.${tableCellClasses.body}`]: {
    fontSize: 14,
    textAlign: "left",
  },
}));

export const NormalWidthStyledTableCell = styled(TableCell)(({ theme }) => ({
  [`&.${tableCellClasses.head}`]: {
    backgroundColor: "#62626E",
    color: theme.palette.common.white,
    textAlign: "left",
    fontWeight: "bold",
  },
  "&.text-wrapper": {
    width: "150px",
    // overflowWrap: "anywhere"
  },
  "&.wrapLargeText": {
    overflowWrap: "anywhere",
  },
  [`&.${tableCellClasses.body}`]: {
    fontSize: 14,
    textAlign: "left",
  },
}));

export const MediumWidthStyledTableCell = styled(TableCell)(({ theme }) => ({
  [`&.${tableCellClasses.head}`]: {
    backgroundColor: "#62626E",
    color: theme.palette.common.white,
    textAlign: "left",
    fontWeight: "bold",
  },
  "&.text-wrapper": {
    width: "120px",
    // overflowWrap: "anywhere"
  },
  "&.wrapLargeText": {
    overflowWrap: "anywhere",
  },
  [`&.${tableCellClasses.body}`]: {
    fontSize: 14,
    textAlign: "left",
  },
}));

export const ExtraPaddingMediumLeftStyledCell = styled(TableCell)(({ theme }) => ({
  [`&.${tableCellClasses.head}`]: {
    backgroundColor: "#62626E",
    color: theme.palette.common.white,
    textAlign: "left",
    fontWeight: "bold",
    paddingLeft: "40px",
  },
  "&.text-wrapper": {
    maxWidth: "120px",
    // overflowWrap: "anywhere"
  },
  "&.wrapLargeText": {
    overflowWrap: "anywhere",
  },
  [`&.${tableCellClasses.body}`]: {
    fontSize: 14,
    textAlign: "left",
    paddingLeft: "40px",
  },
}));

export const SpecialWidthStyledTableCell = styled(TableCell)(({ theme }) => ({
  [`&.${tableCellClasses.head}`]: {
    backgroundColor: "#62626E",
    color: theme.palette.common.white,
    textAlign: "left",
    fontWeight: "bold",
  },
  "&.text-wrapper": {
    maxWidth: "80px",
    overflowWrap: "anywhere",
  },
  "&.wrapLargeText": {
    overflowWrap: "anywhere",
  },
  [`&.${tableCellClasses.body}`]: {
    fontSize: 14,
    textAlign: "left",
  },
}));

// =============== new definitions for listing data table ===============
export const ListingTableCell = styled(TableCell)(({ theme }) => ({
  [`&.${tableCellClasses.head}`]: {
    backgroundColor: "#62626E",
    color: theme.palette.common.white,
    fontWeight: "bold",
    // IMPORTANT: do NOT set textAlign here
  },
  [`&.${tableCellClasses.body}`]: {
    fontSize: 14,
    // IMPORTANT: do NOT set textAlign here
  },
  "&.text-wrapper": {
    maxWidth: "150px",
  },
  "&.wrapLargeText": {
    overflowWrap: "anywhere",
  },
}));

export const ListingCellContent = styled(Box)(() => ({
  display: "flex",
  alignItems: "center",// vertical centering inside the cell
  width: "100%",
  minHeight: 28,          // consistent baseline across rows
}));

export const ListingCellLeft = styled(ListingCellContent)(() => ({
  justifyContent: "flex-start",
}));

export const ListingCellCenter = styled(ListingCellContent)(() => ({
  justifyContent: "center", // horizontal centering
  gap: 12,   // controls spacing between device blocks
}));

export const ListingCellRight = styled(ListingCellContent)(() => ({
  justifyContent: "flex-end",
}));

// for icon + number, keeps them grouped and aligned
export const ListingIconMetric = styled(Box)(() => ({
  display: "inline-flex",
  flexDirection: "column",
  alignItems: "center",
  justifyContent: "center",
  gap: 2,          // small spacing between icon and number/text
  lineHeight: 1,
  marginTop: 12,      // slight top margin to help vertical centering feel
}));

export const ListingMetricValue = styled(Box)(() => ({
  minWidth: 32,
  textAlign: "center",
}));

export const ListingHeaderContent = styled(Box)(() => ({
  display: "inline-flex",
  alignItems: "center",  // vertical centering
  gap: 4,                // space between label and icon
  lineHeight: 1,
}));